(function() { module.exports = this["styled"]; }());